module.exports = __webpack_public_path__ + "static/media/oxford_dark.580c4f57.png";